import { useCallback } from 'react'

import { signUp } from 'components/views/logged_out/SignUp/Helpers'
import ScAnalytics, { actions } from 'classes/sc_analytics'
import { modalEnum } from 'components/modals/v2/modal'
import AuthHelper from 'helpers/auth_helper'
import { useModalContext, useRootContext } from 'hooks/use_context'

const useSignUpByEmail = (setError) => {
  const modalContext = useModalContext()
  const rootContext = useRootContext()

  const _sendEvent = useCallback((oauth) => {
    ScAnalytics.sendMetric(actions.userCreateFunnel.generalInfo, {
      signup_divided_steps_flow: true,
      ...(oauth && { oauth }),
    })
  }, [])

  const onSubmit = useCallback(
    async (formData) => {
      rootContext.setLoading(true)
      const res = await signUp(formData)
      rootContext.setLoading(false)
      if (res.error) return setError(res.message)
      _sendEvent()
      await rootContext.onAuthSuccess()
      AuthHelper.performLoginRedirect()
      modalContext.onOpenModal(modalEnum.signUpAdditionalDetails)
    },
    [setError, rootContext.setLoading, rootContext.onAuthSuccess]
  )

  return onSubmit
}

export default useSignUpByEmail
